import React from "react";
import { pricing, pricingNote } from "../data/pricing";
import { Check } from "lucide-react";

export const Tarifs = () => {
  return (
    <section id="tarifs" data-testid="tarifs-section" className="py-24 md:py-32 bg-[#0E1A2B]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#C9A869]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A869]">Tarifs</span>
            <span className="h-px w-10 bg-[#C9A869]" />
          </div>
          <h2 className="serif font-light text-4xl md:text-5xl lg:text-6xl text-[#F7F3EA] tracking-tight">
            Des tarifs <span className="italic gold-text">clairs et adaptables</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-0 md:border md:border-[#C9A869]/30">
          {pricing.map((p, i) => (
            <div
              key={i}
              data-testid={`pricing-card-${i}`}
              className={`p-10 md:p-12 border border-[#C9A869]/30 md:border-0 md:border-r md:last:border-r-0 ${
                p.highlight ? "bg-[#1A2A40] relative" : "bg-[#0E1A2B]"
              } flex flex-col`}
            >
              {p.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C9A869] text-[#0E1A2B] text-[10px] tracking-[0.3em] uppercase px-4 py-1">
                  Recommandé
                </span>
              )}
              <p className="text-[10px] tracking-[0.3em] uppercase text-[#C9A869] mb-3">{p.unit}</p>
              <h3 className="serif text-3xl text-[#F7F3EA] mb-3 font-light">{p.title}</h3>
              <div className="flex items-baseline gap-2 mb-5">
                <span className="serif text-6xl text-[#C9A869] font-light">{p.price}</span>
              </div>
              <p className="text-sm text-[#F7F3EA]/65 leading-relaxed font-light flex-1">{p.description}</p>
              <ul className="mt-6 space-y-2 text-sm text-[#F7F3EA]/80">
                <li className="flex items-center gap-2"><Check size={14} className="text-[#C9A869]" /> Particulier ou en couple</li>
                <li className="flex items-center gap-2"><Check size={14} className="text-[#C9A869]" /> Domicile ou lieu public</li>
                <li className="flex items-center gap-2"><Check size={14} className="text-[#C9A869]" /> Tous niveaux acceptés</li>
              </ul>
              <a
                href="#contact"
                data-testid={`pricing-cta-${i}`}
                className={`mt-8 inline-flex justify-center items-center px-7 py-3 text-[11px] tracking-[0.25em] uppercase transition-colors duration-500 ${
                  p.highlight
                    ? "bg-[#C9A869] text-[#0E1A2B] hover:bg-[#DCC28E]"
                    : "border border-[#C9A869] text-[#C9A869] hover:bg-[#C9A869] hover:text-[#0E1A2B]"
                }`}
              >
                {p.cta}
              </a>
            </div>
          ))}
        </div>

        <p className="mt-10 max-w-3xl mx-auto text-center text-sm text-[#F7F3EA]/65 font-light leading-relaxed">
          {pricingNote}
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <a
            href="#contact"
            data-testid="tarifs-cta-devis"
            className="px-8 py-4 border border-[#C9A869] text-[#C9A869] text-[11px] tracking-[0.25em] uppercase hover:bg-[#C9A869] hover:text-[#0E1A2B] transition-colors duration-500"
          >
            Demander un devis
          </a>
          <a
            href="#contact"
            data-testid="tarifs-cta-reserver"
            className="px-8 py-4 bg-[#C9A869] text-[#0E1A2B] text-[11px] tracking-[0.25em] uppercase hover:bg-[#DCC28E] transition-colors duration-500"
          >
            Réserver un premier cours
          </a>
        </div>
      </div>
    </section>
  );
};
